<template>
  <div class="privacy-policy py-4">
    <p class="pp-brand-name">MY LIFE CLICK</p>
    <p class="pp-brand-sub"><em>una soluzione SIGABRAD</em></p>
    <p class="pp-brand-doc"><em>CNPJ: 44.360.218/0001-22</em></p>

    <h1 class="pp-title">
      Informativa sulla Privacy, Protezione dei Dati e Termini di Utilizzo
    </h1>
    <p class="pp-legal-basis">
      <em
        >Ai sensi della Legge n. 13.709/2018 (Legge Generale sulla Protezione
        dei Dati Personali del Brasile – LGPD), del Marco Civile di Internet
        (Legge n. 12.965/2014), del Codice di Difesa del Consumatore (Legge n.
        8.078/1990) e delle linee guida vigenti dell'Autorità Nazionale per la
        Protezione dei Dati del Brasile (ANPD)</em
      >
    </p>
    <p class="pp-meta">
      Versione aggiornata — 25 agosto 2026 · Sostituisce integralmente la
      versione di agosto 2021
    </p>

    <h2 class="pp-section">
      1. Natura di questo Documento e Responsabilità per la sua Compilazione
    </h2>
    <p>
      Questo è un documento modello (template), strutturato da My Life Click /
      SIGABRAD per l'uso da parte dei propri clienti acquirenti — ospedali,
      cliniche, istituti scolastici, organizzatori di eventi, aziende e altre
      persone giuridiche che concedono in licenza la piattaforma per
      l'identificazione dei propri interessati (pazienti, studenti,
      collaboratori, partecipanti, ecc.).
    </p>
    <p>
      Tutti i campi indicati come "[da compilare a cura dell'Acquirente]" in
      questo documento sono di responsabilità esclusiva dell'Acquirente dei
      prodotti My Life Click, che dovrà completarli, convalidarli con la propria
      consulenza legale e pubblicarli prima di rendere disponibile il servizio
      ai propri interessati finali. My Life Click non compila, non convalida e
      non assume alcuna responsabilità per il contenuto di tali campi.
    </p>

    <h2 class="pp-section">
      2. Identificazione delle Parti e dei Ruoli (Titolare x Responsabile)
    </h2>
    <p>
      Ai sensi dell'Art. 5, VI e VII, della LGPD, si distinguono due ruoli in
      questo rapporto:
    </p>
    <ul class="pp-list">
      <li>
        My Life Click / SIGABRAD agisce, di norma, come Responsabile del
        trattamento — fornisce la tecnologia di identificazione digitale (QR
        Code, NFC e RFID), l'infrastruttura della piattaforma e, quando
        incaricata, il supporto al trattamento dei dati per conto e ordine
        dell'Acquirente.
      </li>
      <li>
        Acquirente dei prodotti My Life Click: persona giuridica che sottoscrive
        la piattaforma e la mette a disposizione dei propri interessati. È
        l'Acquirente che, di norma, riveste il ruolo di Titolare del trattamento
        nei confronti di tali interessati finali, spettando a lui le decisioni
        sulla finalità e sulle modalità del trattamento dei dati raccolti
        tramite braccialetti, tessere e altri dispositivi consegnati ai propri
        utenti.
      </li>
      <li>
        In caso di dubbi, contattare l'indirizzo e-mail
        <a href="mailto:yusefwehbe@gmail.com">yusefwehbe@gmail.com</a>
      </li>
      <li>
        <strong>Identificazione dell'Acquirente/Titolare: </strong>
        <em class="pp-placeholder"
          >[da compilare a cura dell'Acquirente — ragione sociale, codice
          fiscale/P.IVA, indirizzo e dati di contatto]</em
        >
      </li>
    </ul>
    <p class="pp-note">
      <em
        >Nota: nelle implementazioni specifiche in cui My Life Click operi
        direttamente in modalità B2C (rapporto diretto con il consumatore
        finale, senza un Acquirente istituzionale intermediario), My Life Click
        assume il ruolo di Titolare del trattamento e deve compilare questi
        stessi campi con i propri dati.</em
      >
    </p>
    <p>
      Il Titolare del trattamento sopra identificato è responsabile delle
      decisioni relative al trattamento dei dati personali raccolti tramite il
      sito, i braccialetti, le tessere e gli altri dispositivi di
      identificazione con tecnologia QR Code, NFC e RFID, le applicazioni e i
      canali di assistenza associati alla propria implementazione della
      piattaforma.
    </p>

    <h2 class="pp-section">3. Definizioni</h2>
    <ul class="pp-list">
      <li>
        <strong>Dato personale:</strong> informazione relativa a una persona
        fisica identificata o identificabile.
      </li>
      <li>
        <strong>Dato personale sensibile:</strong> dato relativo alla salute,
        all'origine etnica, alla convinzione religiosa, all'opinione politica,
        al dato genetico o biometrico, quando collegato a una persona fisica.
      </li>
      <li>
        <strong>Interessato:</strong> persona fisica a cui si riferiscono i dati
        personali oggetto del trattamento.
      </li>
      <li>
        <strong>Trattamento:</strong> qualsiasi operazione effettuata con dati
        personali, come raccolta, uso, accesso, conservazione, cancellazione e
        condivisione.
      </li>
      <li>
        <strong>Titolare del trattamento:</strong> persona giuridica a cui
        competono le decisioni relative al trattamento dei dati personali.
      </li>
      <li>
        <strong>Responsabile del trattamento:</strong> persona giuridica che
        effettua il trattamento dei dati personali per conto del Titolare.
      </li>
      <li>
        <strong>Responsabile della Protezione dei Dati (DPO):</strong>
        persona designata per fungere da canale di comunicazione tra il
        Titolare, gli interessati e l'ANPD.
      </li>
      <li>
        <strong>ANPD:</strong> Autorità Nazionale per la Protezione dei Dati del
        Brasile.
      </li>
    </ul>

    <h2 class="pp-section">4. Dati Personali Raccolti</h2>
    <p>
      In ragione della natura multiverticale della piattaforma — identificazione
      di interessati con malattie croniche, Disturbo dello Spettro Autistico e
      ADHD (nell'ambito del programma PIPTEA, ai sensi della Legge Federale n.
      13.977/2020), malattie rare, identificazione di animali domestici,
      sicurezza aziendale e grandi eventi —, My Life Click potrà trattare le
      seguenti categorie di dati, sempre limitate al minimo necessario per
      ciascuna finalità (principio di necessità, Art. 6, III):
    </p>
    <h3 class="pp-subsection">4.1. Dati anagrafici</h3>
    <ul class="pp-list">
      <li>
        Nome completo, e-mail, cellulare, password di accesso e lingua
        preferita.
      </li>
      <li>
        Dati del rappresentante legale, quando l'interessato sia un minore, un
        adolescente o una persona con disabilità sottoposta a tutela o
        rappresentanza.
      </li>
    </ul>
    <h3 class="pp-subsection">
      4.2. Dati sensibili relativi alla salute (quando forniti volontariamente
      dall'interessato o dal suo rappresentante)
    </h3>
    <ul class="pp-list">
      <li>
        Condizioni mediche, diagnosi, allergie, farmaci in uso e contatti di
        emergenza, collegati al braccialetto o alla tessera di identificazione.
      </li>
      <li>
        Informazioni relative alla diagnosi di Disturbo dello Spettro
        Autistico/ADHD, esclusivamente per finalità di identificazione e
        protezione dell'interessato, ai sensi della Legge n. 13.977/2020 (Legge
        Romeo Mion / PIPTEA).
      </li>
    </ul>
    <h3 class="pp-subsection">4.3. Dati di navigazione</h3>
    <ul class="pp-list">
      <li>
        Indirizzo IP, tipo di dispositivo, cookie e identificatori di sessione,
        raccolti in conformità con l'Informativa sui Cookie (Sezione 13).
      </li>
    </ul>
    <h3 class="pp-subsection">4.4. Dati di terzi collegati</h3>
    <ul class="pp-list">
      <li>
        Quando l'interessato inserisce dati di persone a carico, animali
        domestici o persone sotto la propria responsabilità, è lo stesso
        interessato a essere responsabile di ottenere il consenso o di disporre
        della base giuridica applicabile per la registrazione di tali dati.
      </li>
    </ul>

    <h2 class="pp-section">5. Finalità e Base Giuridica del Trattamento</h2>
    <p>
      Ogni finalità di trattamento è associata a una specifica base giuridica
      prevista dagli Artt. 7 e 11 della LGPD, come descritto di seguito. Il
      trattamento dei dati sensibili relativi alla salute è soggetto a un rigore
      aggiuntivo, essendo effettuato solo con consenso specifico, evidenziato e
      informato dell'interessato o del suo rappresentante legale.
    </p>
    <div class="pp-table-wrap">
      <table class="pp-table">
        <thead>
          <tr>
            <th>Finalità del trattamento</th>
            <th>Base giuridica (LGPD)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Registrazione e creazione dell'account</td>
            <td>
              Esecuzione del contratto / misure precontrattuali (Art. 7, V)
            </td>
          </tr>
          <tr>
            <td>
              Emissione e associazione del braccialetto/tessera di
              identificazione (QR Code, NFC, RFID)
            </td>
            <td>
              Esecuzione del contratto e, se applicabile, tutela della vita o
              dell'incolumità fisica dell'interessato (Art. 7, VII)
            </td>
          </tr>
          <tr>
            <td>
              Dati sanitari collegati a malattie croniche, Disturbo dello
              Spettro Autistico/ADHD (PIPTEA) e malattie rare
            </td>
            <td>
              Consenso specifico ed evidenziato dell'interessato o del suo
              rappresentante legale, per la tutela della salute, in una
              procedura svolta esclusivamente da professionisti sanitari o enti
              sanitari (Art. 11, II, "f")
            </td>
          </tr>
          <tr>
            <td>Comunicazioni, offerte e promozioni via e-mail</td>
            <td>Consenso (opt-in), revocabile in qualsiasi momento</td>
          </tr>
          <tr>
            <td>Metriche di utilizzo, analytics e cookie non essenziali</td>
            <td>
              Consenso, in base alle preferenze impostate dall'interessato
            </td>
          </tr>
          <tr>
            <td>Adempimento di un obbligo legale o regolamentare</td>
            <td>Obbligo legale o regolamentare del Titolare (Art. 7, II)</td>
          </tr>
          <tr>
            <td>Prevenzione delle frodi e sicurezza dell'interessato</td>
            <td>
              Legittimo interesse del Titolare, con valutazione d'impatto (Art.
              7, IX)
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p class="pp-note">
      <em
        >Nota: il consenso per i dati sensibili è sempre richiesto in modo
        evidenziato, separato dagli altri termini di utilizzo, con finalità
        specifica e determinata, ai sensi dell'Art. 11, I, della LGPD.</em
      >
    </p>

    <h2 class="pp-section">6. Consenso</h2>
    <p>
      Il consenso è libero, informato e inequivocabile, raccolto mediante un
      meccanismo di accettazione attiva (non pre-selezionata), al momento della
      registrazione. L'interessato può revocare il consenso in qualsiasi
      momento, tramite richiesta al Responsabile della Protezione dei Dati,
      fermo restando la liceità del trattamento effettuato prima della revoca.
    </p>
    <p>
      Per i dati di bambini e adolescenti, il consenso è ottenuto specificamente
      dal rappresentante legale, nel rispetto del migliore interesse del minore,
      ai sensi dell'Art. 14 della LGPD e dello Statuto del Bambino e
      dell'Adolescente (Estatuto da Criança e do Adolescente).
    </p>

    <h2 class="pp-section">7. Condivisione dei Dati</h2>
    <p>
      My Life Click non condivide dati personali con terzi per finalità
      commerciali estranee alla prestazione del servizio. La condivisione
      avviene esclusivamente nelle seguenti ipotesi:
    </p>
    <ul class="pp-list">
      <li>
        Con responsabili incaricati per hosting, elaborazione dei pagamenti e
        supporto tecnico, mediante contratto che garantisca uno standard di
        protezione equivalente.
      </li>
      <li>
        Con professionisti sanitari, squadre di emergenza o enti pubblici, al
        momento della lettura del QR Code/NFC, per finalità di tutela della vita
        e dell'incolumità fisica dell'interessato.
      </li>
      <li>
        Con partner istituzionali (ospedali, cliniche, enti di supporto alle
        malattie rare, istituti scolastici), esclusivamente sulla base di una
        base giuridica e/o del consenso specifico dell'interessato.
      </li>
      <li>
        Per obbligo di legge, ordine giudiziario o richiesta di un'autorità
        competente.
      </li>
    </ul>
    <p>
      Il Titolare del trattamento richiede a tutti i responsabili e partner il
      rispetto di obblighi equivalenti a quelli previsti dalla LGPD,
      formalizzati in un contratto o accordo di trattamento dei dati (DPA).
    </p>

    <h2 class="pp-section">8. Trasferimento Internazionale dei Dati</h2>
    <p>
      Qualora i dati personali vengano trasferiti a server o fornitori di
      servizi situati al di fuori del territorio nazionale brasiliano, tale
      trasferimento rispetterà una delle ipotesi previste dall'Art. 33 della
      LGPD, inclusa l'esistenza di una decisione di adeguatezza dell'ANPD,
      clausole contrattuali standard, norme aziendali vincolanti globali o
      marchi e certificazioni riconosciuti, garantendo un livello di protezione
      adeguato ai dati trasferiti.
    </p>

    <h2 class="pp-section">9. Conservazione e Cancellazione dei Dati</h2>
    <p>
      I dati personali sono conservati solo per il periodo necessario
      all'adempimento delle finalità per cui sono stati raccolti, nel rispetto
      dei termini di conservazione obbligatoria previsti dalla legge (fiscale,
      civile e regolamentare). Conclusa la finalità, i dati vengono cancellati o
      anonimizzati, salve le ipotesi previste dall'Art. 16 della LGPD
      (adempimento di un obbligo legale, studio da parte di un ente di ricerca,
      trasferimento a terzi nel rispetto dei requisiti di trattamento, oppure
      uso esclusivo del Titolare, con divieto di accesso da parte di terzi,
      purché i dati siano anonimizzati).
    </p>

    <h2 class="pp-section">10. Sicurezza delle Informazioni</h2>
    <p>
      Il Titolare adotta misure tecniche e amministrative idonee a proteggere i
      dati personali da accessi non autorizzati e da situazioni accidentali o
      illecite di distruzione, perdita, alterazione, comunicazione o diffusione,
      tra cui: crittografia dei dati sensibili in transito e a riposo, controllo
      degli accessi basato sul ruolo (minimo privilegio), autenticazione a più
      fattori per l'accesso amministrativo, registrazione (log) degli accessi e
      tracciabilità di audit, e test di sicurezza periodici.
    </p>
    <p>
      In caso di incidente di sicurezza che possa comportare un rischio o un
      danno rilevante per gli interessati, il Titolare comunicherà all'ANPD e
      agli interessati coinvolti entro un termine ragionevole, ai sensi
      dell'Art. 48 della LGPD, informando sulla natura dei dati coinvolti, sulle
      misure tecniche adottate e sui rischi connessi all'incidente.
    </p>

    <h2 class="pp-section">11. Diritti dell'Interessato</h2>
    <p>
      Ai sensi dell'Art. 18 della LGPD, l'interessato ha diritto di ottenere dal
      Titolare, in qualsiasi momento e su richiesta:
    </p>
    <div class="pp-table-wrap">
      <table class="pp-table pp-table--rights">
        <tbody>
          <tr>
            <th>Conferma e accesso</th>
            <td>
              Sapere se i propri dati sono trattati e accedere al contenuto
              trattato.
            </td>
          </tr>
          <tr>
            <th>Rettifica</th>
            <td>Correggere dati incompleti, inesatti o non aggiornati.</td>
          </tr>
          <tr>
            <th>Anonimizzazione, blocco o cancellazione</th>
            <td>
              Di dati non necessari, eccessivi o trattati in difformità dalla
              LGPD.
            </td>
          </tr>
          <tr>
            <th>Portabilità</th>
            <td>
              Richiedere il trasferimento dei dati a un altro fornitore di
              servizi, mediante richiesta espressa.
            </td>
          </tr>
          <tr>
            <th>Cancellazione</th>
            <td>
              Cancellazione dei dati personali trattati con consenso, salve le
              ipotesi di conservazione obbligatoria.
            </td>
          </tr>
          <tr>
            <th>Informazioni sulla condivisione</th>
            <td>
              Sapere con quali enti pubblici e privati il Titolare ha condiviso
              i dati.
            </td>
          </tr>
          <tr>
            <th>Informazioni sulla possibilità di non prestare il consenso</th>
            <td>E le conseguenze del rifiuto.</td>
          </tr>
          <tr>
            <th>Revoca del consenso</th>
            <td>
              In qualsiasi momento, mediante dichiarazione espressa, senza
              pregiudicare la liceità del trattamento precedente.
            </td>
          </tr>
          <tr>
            <th>Riesame di decisioni automatizzate</th>
            <td>
              Richiedere il riesame umano di decisioni prese unicamente sulla
              base di un trattamento automatizzato.
            </td>
          </tr>
          <tr>
            <th>Opposizione</th>
            <td>
              Opporsi al trattamento effettuato sulla base di un presupposto
              giuridico diverso dal consenso, in caso di violazione della LGPD.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p>
      Le richieste possono essere effettuate tramite il canale indicato nella
      Sezione 12 e riceveranno risposta entro un termine ragionevole, nel
      rispetto dei termini regolamentari dell'ANPD.
    </p>

    <h2 class="pp-section">12. Responsabile della Protezione dei Dati (DPO)</h2>
    <p>
      Il Titolare (Acquirente, ai sensi della Sezione 2) nomina un Responsabile
      della Protezione dei Dati (Data Protection Officer), incaricato di gestire
      le richieste degli interessati, comunicare con l'ANPD e formare i
      collaboratori sulle pratiche di protezione dei dati.
    </p>
    <p>
      <strong>Canale di assistenza per l'interessato / DPO: </strong>
      <em class="pp-placeholder"
        >[da compilare a cura dell'Acquirente — nome del DPO, e-mail dedicata
        alla privacy e canale di contatto ufficiale]</em
      >
    </p>
    <p class="pp-note">
      <em
        >Campo di responsabilità esclusiva dell'Acquirente, da compilare prima
        della pubblicazione di questo documento ai propri interessati — si
        raccomanda un'e-mail dedicata alla privacy, distinta dall'e-mail
        commerciale, per la tracciabilità delle richieste ricevute.</em
      >
    </p>

    <h2 class="pp-section">13. Cookie</h2>
    <p>
      Il sito e la piattaforma My Life Click utilizzano cookie per abilitare
      funzionalità essenziali (account, accesso, elaborazione degli ordini),
      migliorare l'esperienza dell'utente ed effettuare analisi di utilizzo,
      anche tramite strumenti di terze parti come Google Analytics.
    </p>
    <h3 class="pp-subsection">13.1. Categorie di cookie</h3>
    <ul class="pp-list">
      <li>
        Strettamente necessari: essenziali per il funzionamento del sito e la
        sicurezza dell'account; non richiedono consenso preventivo.
      </li>
      <li>
        Di prestazione e analytics: raccolgono dati aggregati sull'utilizzo del
        sito; richiedono il consenso dell'interessato.
      </li>
      <li>
        Di funzionalità: memorizzano le preferenze dell'utente (lingua,
        impostazioni).
      </li>
      <li>
        Di terze parti: cookie impostati da partner di analisi, soggetti alle
        rispettive informative sulla privacy.
      </li>
    </ul>
    <p>
      L'interessato può gestire le proprie preferenze sui cookie in qualsiasi
      momento tramite il banner di consenso o le impostazioni del browser. La
      disattivazione dei cookie non essenziali non compromette il funzionamento
      di base del sito; la disattivazione dei cookie essenziali può
      compromettere funzionalità come l'accesso e l'elaborazione degli ordini.
    </p>

    <h2 class="pp-section">
      14. Dati di Minori, Adolescenti e Persone con Disabilità
    </h2>
    <p>
      Considerato che parte delle verticali di My Life Click è destinata
      all'identificazione di minori e persone con Disturbo dello Spettro
      Autistico (programma PIPTEA), il trattamento dei dati di tali interessati
      osserva una protezione rafforzata: raccolta limitata a quanto strettamente
      necessario per la finalità di identificazione e protezione, consenso
      specifico del rappresentante legale, divieto di utilizzo dei dati per
      finalità pubblicitarie rivolte a queste categorie di interessati, e
      possibilità di cancellazione dei dati in qualsiasi momento su richiesta
      del rappresentante legale.
    </p>

    <h2 class="pp-section">15. Impegno dell'Utente</h2>
    <p>Utilizzando la piattaforma My Life Click, l'utente si impegna a:</p>
    <ul class="pp-list">
      <li>
        Non utilizzare i servizi per finalità illecite o contrarie all'ordine
        pubblico.
      </li>
      <li>
        Non diffondere contenuti discriminatori, razzisti, xenofobi, di apologia
        della violenza o di attività illegali.
      </li>
      <li>
        Non tentare di compromettere la sicurezza dei sistemi del Titolare, di
        fornitori o di terzi, inclusi tentativi di introduzione di virus,
        malware o reverse engineering non autorizzato.
      </li>
      <li>
        Fornire informazioni veritiere, accurate e aggiornate al momento della
        registrazione.
      </li>
    </ul>

    <h2 class="pp-section">16. Proprietà Intellettuale e Licenza d'Uso</h2>
    <p>
      I materiali disponibili sul sito e sulla piattaforma My Life Click (testi,
      marchio, layout, software e tecnologia di identificazione QR
      Code/NFC/RFID) sono protetti da diritti d'autore e di proprietà
      industriale. All'utente viene concessa una licenza limitata, personale,
      non esclusiva e non trasferibile per l'uso dei servizi in base alla loro
      finalità, con divieto di copia, modifica, reverse engineering,
      distribuzione o sfruttamento commerciale non autorizzato dei materiali.
    </p>

    <h2 class="pp-section">17. Esclusione e Limitazione di Responsabilità</h2>
    <p>
      I materiali e i servizi sono forniti "così come sono". My Life Click non
      fornisce alcuna garanzia, espressa o implicita, e con la presente esclude
      e nega tutte le altre garanzie, e non è responsabile per danni indiretti
      derivanti dall'uso o dall'impossibilità di utilizzare i servizi, salvo i
      casi di dolo, colpa grave o violazione di una norma sulla protezione dei
      dati imputabile al Titolare, ai sensi del Codice di Difesa del Consumatore
      e della LGPD.
    </p>
    <p class="pp-note">
      <em
        >Nota: le clausole di limitazione della responsabilità nei confronti dei
        consumatori sono soggette alle norme di ordine pubblico del CDC, che
        vietano l'esonero di responsabilità in caso di vizio o difetto del
        servizio; si raccomanda una validazione legale di questa sezione in base
        al pubblico di riferimento (B2C, B2B o settore pubblico).</em
      >
    </p>

    <h2 class="pp-section">18. Link a Siti Esterni</h2>
    <p>
      La piattaforma può contenere link a siti di terze parti. My Life Click non
      esamina né si assume responsabilità per il contenuto, le pratiche sulla
      privacy o la sicurezza di siti esterni, essendo l'accesso a tali siti di
      esclusiva responsabilità dell'utente.
    </p>

    <h2 class="pp-section">19. Modifiche a questa Informativa</h2>
    <p>
      Questa Informativa potrà essere aggiornata in qualsiasi momento, per
      riflettere modifiche legislative, regolamentari o operative. Le modifiche
      rilevanti saranno comunicate agli interessati via e-mail o tramite avviso
      evidenziato sulla piattaforma, con indicazione della nuova data di entrata
      in vigore. L'uso continuato dei servizi dopo la comunicazione della
      modifica implica la conoscenza dei nuovi termini.
    </p>

    <h2 class="pp-section">20. Legge Applicabile e Foro Competente</h2>
    <p>
      Questa Informativa è disciplinata dalle leggi della Repubblica Federativa
      del Brasile, in particolare dalla Legge n. 13.709/2018 (LGPD), dalla Legge
      n. 12.965/2014 (Marco Civile di Internet) e dal Codice di Difesa del
      Consumatore. È eletto il foro del domicilio dell'interessato/consumatore
      per dirimere le controversie derivanti da questa Informativa, salva
      diversa competenza prevista dalla legge, essendo vietata la scelta di un
      foro che ostacoli l'accesso dell'interessato alla giustizia.
    </p>

    <h2 class="pp-section">21. Entrata in Vigore</h2>
    <p>
      Questa Informativa entra in vigore a partire dal 25 agosto 2026 e
      sostituisce integralmente qualsiasi versione precedente pubblicata
      dall'Acquirente.
    </p>

    <hr class="pp-divider" />
    <p class="pp-footnote">
      <em
        >Questo documento è stato redatto da My Life Click a fini organizzativi
        e di aggiornamento dei contenuti, sulla base della legislazione
        brasiliana in materia di protezione dei dati (LGPD) e delle migliori
        pratiche di mercato, come modello (template) da adattare da parte di
        ciascun Acquirente. La compilazione, la convalida e la pubblicazione dei
        campi indicati come "[da compilare a cura dell'Acquirente]" sono di
        responsabilità esclusiva dell'Acquirente dei prodotti My Life Click, al
        quale spetta anche l'analisi da parte di un avvocato o studio legale
        specializzato in protezione dei dati e diritto digitale abilitato nella
        propria giurisdizione, l'adeguamento alle proprie dimensioni e al
        proprio settore di attività (da enti pubblici a multinazionali) e la
        predisposizione di una Valutazione d'Impatto sulla Protezione dei Dati
        (DPIA/RIPD), raccomandata data la natura del trattamento di dati
        sensibili relativi alla salute. My Life Click non si assume alcuna
        responsabilità per i contenuti inseriti dall'Acquirente in tali
        campi.</em
      >
    </p>
  </div>
</template>

<script>
export default {
  name: "privacy-policy-it",
};
</script>
